import { useMemo } from "react";
import { defaultThemeVariables } from "system/styles/constants";

export const useThemeData = (dynamicStyles: any) =>
  useMemo(() => {
    return { ...defaultThemeVariables, ...dynamicStyles };
  }, [dynamicStyles]);
